// Ссылки для оплаты через Telegram бот
export const PAYMENT_LINKS = {
  RUB: 'https://t.me/pauline_secret_bot?start=cmd_run_127164857',
  EUR: 'https://t.me/pauline_secret_bot?start=cmd_run_3561091970',
} as const

export type PaymentCurrency = keyof typeof PAYMENT_LINKS 